import React from 'react';
import { DevisSummary } from '../types';
import { formatPrix } from '../utils/priceParsing';

interface DevisSummaryBarProps {
  summary: DevisSummary;
}

const DevisSummaryBar: React.FC<DevisSummaryBarProps> = ({ summary }) => {
  const ecartColor =
    summary.ecartPercent <= 5
      ? 'text-green-600'
      : summary.ecartPercent <= 20
        ? 'text-orange-600'
        : 'text-red-600';

  const ecartBg =
    summary.ecartPercent <= 5
      ? 'bg-green-50 border-green-200'
      : summary.ecartPercent <= 20
        ? 'bg-orange-50 border-orange-200'
        : 'bg-red-50 border-red-200';

  if (summary.linesTotal === 0) return null;

  return (
    <div className={`mb-4 rounded-xl border p-4 ${ecartBg}`}>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {/* Total devis */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Total devis</div>
          <div className="text-lg font-semibold text-gray-900">
            {formatPrix(summary.totalDevis)} €
          </div>
        </div>

        {/* Total benchmark */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Total benchmark (moy)</div>
          <div className="text-lg font-semibold text-gray-900">
            {summary.totalBenchmarkAvg > 0
              ? `${formatPrix(summary.totalBenchmarkAvg)} €`
              : '—'}
          </div>
        </div>

        {/* Écart € */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Écart global</div>
          <div className={`text-lg font-semibold ${ecartColor}`}>
            {summary.totalBenchmarkAvg > 0
              ? `${summary.ecartTotal >= 0 ? '+' : ''}${formatPrix(summary.ecartTotal)} €`
              : '—'}
          </div>
        </div>

        {/* Écart % */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Écart %</div>
          <div className={`text-lg font-semibold ${ecartColor}`}>
            {summary.totalBenchmarkAvg > 0
              ? `${summary.ecartPercent >= 0 ? '+' : ''}${summary.ecartPercent.toFixed(1)}%`
              : '—'}
          </div>
        </div>

        {/* Lignes matchées */}
        <div>
          <div className="text-xs text-gray-500 mb-1">Lignes matchées</div>
          <div className="text-lg font-semibold text-gray-900">
            {summary.linesMatched}/{summary.linesTotal}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DevisSummaryBar;
